module.exports = __webpack_public_path__ + "51b6c3cc5d1d3071dee940d7d190fbbb.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/LI.svg
// module id = AqMp
// module chunks = 0